var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    width: 55,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".prefix__shp1{fill:none;stroke:#fff;stroke-width:3}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_11527-2",
    d: "M27.5 0c11.13 0 21.15 6.7 25.41 16.98 4.26 10.28 1.9 22.1-5.96 29.97a27.504 27.504 0 01-29.97 5.96A27.498 27.498 0 010 27.5c0-3.61.71-7.18 2.1-10.52 1.38-3.34 3.4-6.37 5.96-8.92 2.55-2.56 5.58-4.58 8.92-5.96C20.32.71 23.89 0 27.5 0z",
    fill: "#ff5a53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_14727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_467",
    className: "prefix__shp1",
    d: "M20 20l15 15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_468",
    className: "prefix__shp1",
    d: "M35 20L20 35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.95de4475.svg";
export { ForwardRef as ReactComponent };